import axios from 'axios'

export const postPayment = payload => axios.post('alibabapackage/recurring_payments', payload)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getPckgMembership = () => {
  return axios.get('alibabapackage/membership')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPckgDesignShop = () => {
  return axios.get('alibabapackage/designshop')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPckgProductUpload = () => {
  return axios.get('alibabapackage/productupload')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getPckgAdditional = () => {
  return axios.get('alibabapackage/additional')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const checkingPromo = (payload) => {
  return axios.post('alibabapackage/promo-checking', payload)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/alibabapayment.api.js